import React from 'react';
import { Typography } from 'antd';

const { Paragraph, Text } = Typography;

const FlatCountError = ({ flatCount, receivedFlatCount }) => {
  return (
    <Paragraph type='danger'>
      <Paragraph style={{ marginBottom: '5px' }} type="danger">
        Количество полученных квартир не совпадает с действующим количеством
      </Paragraph>
      <ul style={{ listStyle: 'none' }}>
        <li>
          <Paragraph style={{ margin: 0 }} type="danger">
            Действующее количество квартир -{' '}
            <Text type="danger" strong>
              {flatCount}
            </Text>
          </Paragraph>
        </li>
        <li>
          <Paragraph style={{ margin: 0 }} type="danger">
            Полученное количество квартир -{' '}
            <Text type="danger" strong>
              {receivedFlatCount}
            </Text>
          </Paragraph>
        </li>
      </ul>
    </Paragraph>
  );
};

export default FlatCountError;
